<template>
  <CollapsibleRoot
    :open="open"
    @update:open="$emit('update:open', $event)"
    :class="props.class"
  >
    <CollapsibleTrigger asChild :data-id="trackingId">
      <slot />
    </CollapsibleTrigger>
    <CollapsibleContent>
      <slot name="content" />
    </CollapsibleContent>
  </CollapsibleRoot>
</template>

<script setup>
import {
  CollapsibleContent,
  CollapsibleRoot,
  CollapsibleTrigger,
} from "radix-vue";

defineEmits(["update:open"]);

const props = defineProps({
  open: { type: Boolean, default: undefined },
  variant: { type: String, required: false },
  class: { type: null, required: false },
  trackingId: { type: String, required: false },
});
</script>
